export const getProjectIdFromSpaState = (projectKey: string): number | undefined => {
	return globalThis?.window?.SPA_STATE?.PROJECT_CONTEXT?.[projectKey]?.data?.projectId;
};
